// src/services/templateDrag.js
//
// The drag payload for a reusable question block ("Use from template").
//
// Its own MIME type, so a drop target can tell a template block apart from an
// outline row reorder (which travels as text/plain) and from a field type
// dragged out of the answer-type palette (see FIELD_TYPE_DRAG) — without
// guessing from the shape of whatever it was handed.
//
// It lives HERE, not in SectionEditor, because two unrelated drop targets read
// it now: the document outline in SectionEditor, and the answer drop zone
// inside QuestionBuilder. SectionEditor imports QuestionBuilder, so QuestionBuilder
// cannot import back from it.

export const TEMPLATE_DRAG_TYPE = "application/x-sourcex-template";

export const isTemplateDrag = (ev) => {
  const types = ev?.dataTransfer?.types;
  if (!types) return false;
  return Array.from(types).includes(TEMPLATE_DRAG_TYPE);
};

export const readTemplateId = (ev) => {
  try {
    return ev.dataTransfer.getData(TEMPLATE_DRAG_TYPE) || "";
  } catch {
    // Some browsers restrict getData outside a drop handler.
    return "";
  }
};
